import React from 'react';
import { NavLink } from './NavLink';

export interface NavItem {
  to: string;
  label: string;
  visible?: boolean;
}

export interface NavigationProps {
  links: NavItem[];
  currentPath: string;
  className?: string;
}

/**
 * Navigation component renders a list of navigation links.
 * Handles conditional visibility and active state detection.
 */
export const Navigation: React.FC<NavigationProps> = ({
  links,
  currentPath,
  className = '',
}) => {
  // Filter to only visible links
  const visibleLinks = links.filter((link) => link.visible !== false);

  return (
    <nav
      className={`flex items-center gap-1 ${className}`}
      role="navigation"
      aria-label="Main navigation"
    >
      {visibleLinks.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          label={link.label}
          isActive={currentPath === link.to}
        />
      ))}
    </nav>
  );
};

export default Navigation;
